export default __webpack_public_path__ + "static/app-features-1--mobile-ec5c04236c2152c1279a591677dbb152.webp";